import { computed } from 'vue';
import { Seo } from './seo.types';
import { POWERED_BY_DEGEN_LAYER } from '@/constants/POWERED_BY_DEGEN_LAYER';
import * as SEO from '@/constants/SEO';
import * as DEGEN_LAYER_SEO from '@/constants/DEGEN_LAYER_SEO';

export const seo = computed<Seo>(() => {
  return POWERED_BY_DEGEN_LAYER ? DEGEN_LAYER_SEO : SEO;
});
